module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep9-ba384d04c63e3574736ec91349709546.wav";